import React, { useState, useEffect } from 'react';

const Snackbar = ({ message, isOpen, onClose , type="success"}) => {
  const [showSnackbar, setShowSnackbar] = useState(isOpen);

  useEffect(() => {
    setShowSnackbar(isOpen);

    let timer;
    
    if (isOpen) {
      // Set a timer to automatically close the Snackbar after 5 seconds
      timer = setTimeout(() => {
        setShowSnackbar(false);
        onClose();
      }, 5000);
    }

    // Clear the timer and close the Snackbar when it unmounts or isOpen becomes false
    return () => {
      clearTimeout(timer);
      if (isOpen) {
        setShowSnackbar(false);
        onClose();
      }
    };
  }, [isOpen, onClose]);

  const closeSnackbar = () => {
    setShowSnackbar(false);
    onClose();
  };

  return (
    <div
      className={`fixed bottom-4 left-0 ${type === 'error' ? "bg-red-400" : "bg-green-500"} text-white p-2 rounded shadow-md transform transition-transform duration-300 ease-in-out ${
        showSnackbar ? 'translate-x-0 left-1' : '-translate-x-full'
      }`}
    >
      <div className="flex items-center">
        <div className="mr-2">{message}</div>
        <button
          className="text-white font-semibold hover:underline focus:outline-none"
          onClick={closeSnackbar}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Snackbar;
